/**
 * @module b-form-row
 */
define('mrg-form/b-form-row/b-form-row', function(require) {
	'use strict';

	var toolkit = require('toolkit/b-toolkit/b-toolkit');

	return toolkit.create('b-form-row', {

		init: function () {

		},

		/**
		 *
		 * @param $input
		 * @private
		 */
		_initInput: function () {},

		/**
		 * Передаем модификатор дальше дочерним блокам
		 *
		 * @param mod
		 * @param state
		 */
		toggleMod: function(mod, state) {
			var field = this.$('.b-form-field').getBlock();

			toolkit['b-toolkit'].fn.toggleMod.call(this, mod, state);
			if (field) {
				field.toggleMod(mod, state);
			}
		}
	});
});
